/**
 * Order of tabs in the Brand Dashboard (generic template) sidebar.
 * Glossary accordion panels follow this order; unknown ids sort last (A–Z).
 */
export const GLOSSARY_TAB_ORDER: string[] = [
  'overview',
  'ai-citations',
  'category-analysis',
  'consumer-insights',
  'sentiment-tracking',
  'ai-content-index',
  'prompt-research',
  'content-creation',
  'performance-tracking',
  'prompt-tracking',
  'eeat-audit',
  'landing-page-audit',
  'ai-audit',
  'ai-visibility',
];

export function compareGlossaryTabOrder(tabNameA: string, tabNameB: string): number {
  const ia = GLOSSARY_TAB_ORDER.indexOf(tabNameA);
  const ib = GLOSSARY_TAB_ORDER.indexOf(tabNameB);
  const aUnknown = ia === -1;
  const bUnknown = ib === -1;
  if (aUnknown && bUnknown) {
    return tabNameA.localeCompare(tabNameB);
  }
  if (aUnknown) {
    return 1;
  }
  if (bUnknown) {
    return -1;
  }
  return ia - ib;
}

/** Maps API `tab_name` (tab id) to a human-readable section title in Glossary / admin UI. */
export const TAB_NOTE_DISPLAY_LABELS: Record<string, string> = {
  overview: 'Overview',
  'ai-citations': 'AI Citations',
  'category-analysis': 'Category Analysis',
  'sentiment-tracking': 'Sentiment Tracking',
  'consumer-insights': 'Consumer Insights',
  'ai-content-index': 'AI Content Index',
  'content-creation': 'Content Creation',
  'performance-tracking': 'Performance Tracking',
  'eeat-audit': 'EEAT Audit',
  'landing-page-audit': 'Landing Page Audit',
  'ai-audit': 'AI Audit',
  'prompt-research': 'Prompt Creation',
  'prompt-tracking': 'Prompt Tracking',
  'ai-visibility': 'AI Visibility',
};

export function tabNoteDisplayLabel(tabName: string): string {
  return TAB_NOTE_DISPLAY_LABELS[tabName] ?? formatTabNameFallback(tabName);
}

function formatTabNameFallback(tabName: string): string {
  return tabName
    .split(/[-_]/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
